module.exports = __webpack_public_path__ + "stylesheets/wave-template-item_3ffadc4d4a77a9a490fb26a29be11098.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/wave/wave-template-item.less
// module id = aTCW
// module chunks = 154